import { useContext } from "react";
import { UseQueryResult, useQuery } from "@tanstack/react-query";

import { AxiosContext } from "contexts/AxiosContext";
import { API_URL_SCHEDULED_RUNS } from "constants/api_urls";
import { ScheduledRunsResponse } from "interfaces/scheduled-runs";
import { makeQueryString } from "core/makeQueryString";

export const useScheduledRunsQuery = ({
  page = 1,
  pageSize = 10000
}: { page?: number; pageSize?: number } = {}): UseQueryResult<
  ScheduledRunsResponse,
  unknown
> => {
  const { axios } = useContext(AxiosContext)!;

  const queryString = makeQueryString({ page, size: pageSize });

  return useQuery({
    queryKey: ["scheduledRuns"],
    queryFn: async () => {
      const { data } = await axios.get<ScheduledRunsResponse>(
        `${API_URL_SCHEDULED_RUNS}${queryString}`
      );
      return data;
    }
  });
};
